import axios from '../../../axios';
import { CrmJobSettingsDTO } from '../types/CrmJobSettingsDTO';

const url = '/invoicingservice/api/crm/job-settings';

export const getCrmJobSettingsByWorkspaceId = (workspaceId: string) =>
  axios.get(`${url}/${workspaceId}`);

export const updateCrmJobSettings = (settings: CrmJobSettingsDTO) => axios.put(`${url}`, settings);

export const createCrmJobSetting = (crmJobSetting: CrmJobSettingsDTO) =>
  axios.post(`${url}`, crmJobSetting);
